import { render, staticRenderFns } from "./sofyre-tabs-review.vue?vue&type=template&id=f8f9bffe&scoped=true&"
import script from "./sofyre-tabs-review.vue?vue&type=script&lang=js&"
export * from "./sofyre-tabs-review.vue?vue&type=script&lang=js&"
import style0 from "./sofyre-tabs-review.vue?vue&type=style&index=0&id=f8f9bffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f9bffe",
  null
  
)

export default component.exports